import React from 'react';
import { Dot } from '@app/react-common/components/dot/Dot';
import { ExtensionGroupStatus } from '../ExtensionGroupsMain';

interface IExtensionStatusDotsProps {
  status: ExtensionGroupStatus;
}

export const ExtensionStatusDots: React.FC<IExtensionStatusDotsProps> = ({ status }) => {
  const renderExtensionStatusDot = (status: ExtensionGroupStatus): React.ReactNode => {
    switch (status) {
      case ExtensionGroupStatus.Enabled:
        return <Dot color="green" hoverText="Enabled" tooltipDirection="left" />;
      case ExtensionGroupStatus.EnabledSegmented:
        return <Dot color="green" hoverText="Segmented live" halfFilled={true} tooltipDirection="left" />;
      case ExtensionGroupStatus.AbTest:
        return <Dot color="darkblue" hoverText="A/B test running" tooltipDirection="left" />;
      case ExtensionGroupStatus.AbTestSegmented:
        return <Dot color="darkblue" hoverText="A/B test running" halfFilled={true} tooltipDirection="left" />;
      case ExtensionGroupStatus.Disabled:
        return <Dot color="gray" hoverText="Disabled" tooltipDirection="left" />;
      case ExtensionGroupStatus.DisabledSegmented:
        return <Dot color="gray" hoverText="Segmented disabled" halfFilled={true} tooltipDirection="left" />;
    }
  };

  return <>{renderExtensionStatusDot(status)}</>;
};
